// Shared constants for the wearable integration (client + server safe).
export const WEARABLE_PROVIDERS = ["fitbit", "oura", "garmin", "whoop", "apple_health"] as const;
export type WearableProvider = (typeof WEARABLE_PROVIDERS)[number];

export const WEARABLE_LABELS: Record<WearableProvider, string> = {
  fitbit: "Fitbit",
  oura: "Oura Ring",
  garmin: "Garmin",
  whoop: "Whoop",
  apple_health: "Apple Watch",
};

export const WEARABLE_DATA_TYPES = [
  "sleep_duration",
  "sleep_quality",
  "hrv",
  "resting_heart_rate",
  "skin_temperature",
  "steps",
] as const;
